function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.75,166.39c17.98,17.98,41.61,26.98,65.23,26.98s47.25-8.99,65.23-26.98l84.33-84.33-21.1-21.1-84.33,84.33c-24.33,24.33-63.93,24.33-88.26,0l-1.25-1.25c-24.33-24.33-24.33-63.93,0-88.26l1.07-1.07c24.33-24.33,63.93-24.33,88.26,0l7.27,7.27,21.1-21.1-7.27-7.27C126.06-2.36,67.54-2.36,31.57,33.61l-1.07,1.07c-35.97,35.97-35.97,94.49,0,130.46l1.25,1.25Z",
    style: {
      fill: "#ff6a4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.04,33.61c-17.98-17.98-41.61-26.98-65.23-26.98-23.62,0-47.25,8.99-65.23,26.98l-84.33,84.33,21.1,21.1,84.33-84.33c24.33-24.33,63.93-24.33,88.26,0l1.25,1.25c24.33,24.33,24.33,63.93,0,88.26l-1.07,1.07c-24.33,24.33-63.93,24.33-88.26,0l-7.27-7.27-21.1,21.1,7.27,7.27c35.97,35.97,94.49,35.97,130.46,0l1.07-1.07c35.97-35.97,35.97-94.49,0-130.46l-1.25-1.25Z",
    style: {
      fill: "#ff6a4c",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.529a002e3d99053f1a2a4d8f1ee150a3.svg";
export { ForwardRef as ReactComponent };